export default  function sumGoodsCount(array) {//合计相同商品 和规格下得条码  入库 出库合计用
				var sumGoodsData = [];
				array.forEach(item => {
					let isDiffIndex = sumGoodsData.findIndex(subitem => {
						return item.goodsId == subitem.goodsId && item.skus == subitem.skus
					})
					// 若不相同商品和规格 children 包含商品条码 sumGoodsDataitem包含相同得商品信息  
					if (isDiffIndex == -1) {
						sumGoodsData.push({
							goodsId: item.goodsId,
							skus: item.skus,
							goodsName: item.goodsName,
							skuValue: item.skuValue,
							unit: item.unit,
							count: 1,
							children: [item]
						})
					} else {
						sumGoodsData[isDiffIndex].count += 1;
						sumGoodsData[isDiffIndex].children.push(item)
						sortCustom(sumGoodsData[isDiffIndex].children)
					}
				})
				console.log(sumGoodsData,array)
				return sumGoodsData;
			}
			// 将children中的条码进行升序排序
 function sortCustom(array){
	return array.sort(function(a,b){return a.customCode-b.customCode});
}